import React from "react";
import {Modal, ModalContent, Text, FlexRowCenter, H2} from "@reside/ui";
import {FacilityDropdownTreeSelect} from "../../../../atoms/facility-dropdown-tree-select";
import {SearchResidentsField} from "../SearchResidentsField";
import {useLinkResidentToAdmissionContext} from "../../context/useLinkResidentToAdmissionContext";
import {LinkAnotherResidentRadioForm} from "./LinkAnotherResidentRadioForm";
import {SearchResidentsContextProvider} from "../../context/useFilterResidentsContext";

export const LinkAnotherResidentModal = ({
  onLinked,
}: {
  onLinked: () => void;
}): JSX.Element => {
  const {admission, toggleModal} = useLinkResidentToAdmissionContext();

  return (
    <Modal
      isOpen={!!admission}
      onRequestClose={() => {
        toggleModal();
      }}
      size="large"
      fullScreen
      title="Link Admission"
    >
      {({closeModal}) => (
        <ModalContent style={{overflowX: "hidden"}}>
          <SearchResidentsContextProvider>
            <FlexRowCenter
              style={{marginBottom: "20px", justifyContent: "space-between"}}
            >
              <FacilityDropdownTreeSelect />

              <SearchResidentsField />
            </FlexRowCenter>

            <Text style={{marginBottom: "40px"}}>
              Select another resident to link this admission. The current
              resident will be unlinked.
            </Text>
            <LinkAnotherResidentRadioForm
              closeModal={closeModal}
              onLinked={onLinked}
            />
          </SearchResidentsContextProvider>
        </ModalContent>
      )}
    </Modal>
  );
};
